import { SignalDoc } from "@megaron/docs-contracts";
import { getMegaraxPath } from "@megaron/megarax-uri";

export const signalHref = (signal: SignalDoc): string | undefined => {
  if (!signal.uri) return undefined;
  return getMegaraxPath.try(signal.uri) ?? signal.uri;
};
